import Logo from "../components/Logo";
import Content from "../components/Content";
import Footer from "../components/Footer";
import privacy from "../data/privacyPolicyData";

function PrivacyPolicy() {

  return (
    <div className="flex flex-col w-full min-h-screen">
      <div className="flex justify-center w-full">
        <Logo
          src="/images/bunat.png"
          alt="Bunat Logo"
          className="w-32 sm:w-40 md:w-48"
        />
      </div>

      <div
        data-aos="fade-up"
        className="grid items-end px-4 sm:px-8 md:px-20 lg:px-36  gap-6"
      >
        <h1 className="text-2xl font-bold text-lightGreen ">
          سياسة الخصوصية
        </h1>

        <p className="text-blackText leading-relaxed  max-w-full sm:max-w-2xl text-right tracking-wide text-sm sm:text-base">
          نحن في بُناة نولي خصوصيتك أهمية قصوى، ونلتزم بحماية بياناتك الشخصية
          وفقًا لأعلى معايير الأمان والشفافية. توضح هذه السياسة كيفية جمع
          المعلومات، واستخدامها، ومشاركتها، وحمايتها ضمن التطبيق.
        </p>
        <Content sections={privacy} />
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
